module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/relation_link_smoker_down-ee807d3f95e76753705ba932cf714d76.png";